import styled from "styled-components";

// =====================================================
// MODERN GRID LIST PRODUCTS STYLES
// Using Inter font, consistent spacing, modern aesthetics
// =====================================================

export const ContGeneral = styled.div`
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");
  
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  justify-content: flex-start;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  background: #f8f9fa;
  min-height: 100vh;
  padding: 24px;
  padding-bottom: 100px;

  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    margin: 0; 
  }
`;

export const ContHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

export const Text = styled.p.attrs(props => ({
  cl: props.cl || '#374151',
  size: props.size || '14px',
  ml: props.ml || '0',
  mr: props.mr || '0',
  fw: props.fw || '400',
  mt: props.mt || '0',
  mb: props.mb || '0',
}))`
  color: ${props => props.cl};
  font-size: ${props => props.size};
  margin-left: ${props => props.ml};
  margin-right: ${props => props.mr};
  font-weight: ${props => props.fw};
  margin-top: ${props => props.mt};
  margin-bottom: ${props => props.mb};
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 1.5;
`;

export const PageTitle = styled.h1`
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
`;

export const ContInputAndLabel = styled.div.attrs(props => ({
  w: props.w || '100%',
  fld: props.fld || 'row',
  jsc: props.jsc || 'flex-start',
  ali: props.ali || 'center',
  mr: props.mr || 0
}))`
  display: flex;
  width: ${props => props.w};
  flex-direction: ${props => props.fld};
  justify-content: ${props => props.jsc};
  align-items: ${props => props.ali};
  margin-right: ${props => props.mr};
  gap: 4px;
`;

export const Input = styled.input`
  display: block;
  width: 100%;
  height: 48px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: #111827;
  padding: 0 16px;
  background-color: #fff;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #7367f0;
    box-shadow: 0 0 0 4px rgba(115, 103, 240, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const InputSearch = styled.input`
  flex: 1;
  height: 48px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: #111827;
  padding: 0 16px;
  background-color: transparent;
  border: none;
  outline: none;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;

  &::placeholder {
    color: #9ca3af;
  }
`;

export const ContInputSearch = styled.form`
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;

  &:focus-within {
    border-color: #7367f0;
    box-shadow: 0 0 0 4px rgba(115, 103, 240, 0.1);
  }
`;

export const ContIconInputSearch = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  background: #7367f0;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #5a4fcf;
  }
`;

export const ContFilterAndListGrid = styled.div`
  display: flex;
  width: 100%;
  gap: 24px;
  align-items: flex-start;
`;

export const ContGridAndCards = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const ContGridCards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  width: 100%;
  margin-top: 20px;
`;

// Floating Action Buttons
export const FloatingActions = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  gap: 12px;
  z-index: 100;
`;

export const BtnSendProduct = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 24px;
  height: 48px;
  background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
  border: none;
  border-radius: 12px;
  color: white;
  font-weight: 600;
  font-size: 14px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.4);
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(115, 103, 240, 0.5);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const BtnAuthorize = styled(BtnSendProduct)`
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
  box-shadow: 0 4px 14px rgba(16, 185, 129, 0.4);

  &:hover:not(:disabled) {
    box-shadow: 0 6px 20px rgba(16, 185, 129, 0.5);
  }
`;

export const BtnSendProductClear = styled(BtnSendProduct)`
  background: #ef4444;
  box-shadow: 0 4px 14px rgba(239, 68, 68, 0.4);

  &:hover:not(:disabled) {
    box-shadow: 0 6px 20px rgba(239, 68, 68, 0.5);
  }
`;

// Tab Container / Modal Overlay
export const TabContainer = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 40px;
  overflow-y: auto;
  transition: opacity 0.3s ease;

  &.hidden {
    opacity: 0;
    pointer-events: none;
  }

  .card {
    background: white;
    border-radius: 16px;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    max-width: 500px;
    width: 100%;
    max-height: 80vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .card-body {
    padding: 24px;
  }

  .card-title {
    font-size: 18px;
    font-weight: 600;
    color: #111827;
    margin: 0;
  }

  .list-style-none {
    list-style: none;
    padding: 0;
    margin: 0;
    max-height: 400px;
    overflow-y: auto;
  }

  .list-style-none > li {
    padding: 12px 16px;
    border-bottom: 1px solid #f3f4f6;
    cursor: pointer;
    transition: background 0.15s ease;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .list-style-none > li:hover {
    background: #f8f7ff;
  }

  .list-style-none > li:last-child {
    border-bottom: none;
  }

  .font-medium {
    font-weight: 500;
    color: #374151;
  }

  .close {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 50%;
    color: #6b7280;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
      color: #7367f0;
      transform: scale(1.1);
    }
  }

  .content {
    position: relative;
  }

  input.filter {
    width: 100%;
    height: 44px;
    padding: 0 16px;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    font-size: 14px;
    font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
    transition: all 0.2s ease;

    &:focus {
      outline: none;
      border-color: #7367f0;
    }
  }
`;

export const ButtonIcon = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: white;
  color: #7367f0;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 16px;

  &:hover:not(:disabled) {
    border-color: #7367f0;
    background: #f8f7ff;
  }

  &.active {
    background: #7367f0;
    border-color: #7367f0;
    color: white;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// Header Actions Row
export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

// Empty State
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  background: white;
  border-radius: 16px;
  border: 2px dashed #e5e7eb;
  margin-top: 20px;

  svg {
    width: 64px;
    height: 64px;
    color: #d1d5db;
    margin-bottom: 16px;
  }

  h3 {
    font-size: 18px;
    font-weight: 600;
    color: #374151;
    margin: 0 0 8px 0;
  }

  p {
    font-size: 14px;
    color: #6b7280;
    margin: 0;
  }
`;